"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSDealsComponent = void 0;
const core_1 = require("@angular/core");
const ngx_owl_carousel_o_1 = require("ngx-owl-carousel-o");
const account_service_1 = require("../services/account.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const router_1 = require("@angular/router");
class CSDealsComponent {
    constructor(accountService, router, modalService) {
        this.accountService = accountService;
        this.router = router;
        this.modalService = modalService;
        // Prepaid deals
        this.dealsContentPrepaid = [];
        // Postpaid deals
        this.dealsContentPostpaid = [];
        this.isHtml = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
        this.upgradeContent = 'UPGRADE NOW';
        this.upgradeOnlyPopUp = 'TAKE ME THERE';
        this.addLineContent = 'ADD A LINE';
        // eslint-disable-next-line max-len
        this.customOptions = {
            margin: 6,
            autoWidth: true,
            autoHeight: true,
            startPosition: 1,
            loop: false,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            dots: false,
            navSpeed: 800,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            lazyLoad: true,
            nav: true,
            items: 2
        };
    }
    ngOnInit() {
        this.getDealsContent();
    }
    getDealsContent() {
        if (this.isPrepaid) {
            this.dealsContent = this.dealsContentPrepaid;
        }
        else {
            this.dealsContent = this.dealsContentPostpaid;
        }
        this.getPulseOffer();
    }
    getPulseOffer() {
        this.loader = true;
        this.accountService.getPulseOffer().subscribe((res) => {
            this.loader = false;
            if (res && Array.isArray(res) && res.length > 0) {
                res.push(...this.dealsContent);
                this.dealsContent = res;
                if (this.dealsContent && this.dealsContent.length > 0) {
                    this.customOptions.items = this.dealsContent.length;
                }
            }
            this.loadDeals();
        }, (err) => {
            this.loadDeals();
            this.loader = false;
        });
    }
    open(content) {
        this.activeModal = this.modalService.open(content, { centered: true });
    }
    loadDeals() {
        if (this.dealsContent && this.dealsContent.length > 0) {
            // set the row count of carousel
            if (window.screen.width <= 575 || this.dealsContent.length === 1) {
                this.mobileView = true;
                this.rowCount = 1;
            }
            else {
                this.rowCount = 2;
            }
            this.showDeals = true;
        }
    }
    nextSlide() {
        // this.owlElement.next([200]);
    }
    prevSlide() {
        // this.owlElement.previous([200]);
    }
    dealsNavigation(event, url, offerActionType) {
        if (this.isHotlined || this.isSecondary || this.isProspect) {
            if (offerActionType === 'Device' || offerActionType === 'Upgrade') {
                event.preventDefault();
                this.modalReference = this.modalService.open(this.errorPopup, { size: 'sm', windowClass: 'dark-modal' });
            }
        }
        else if (offerActionType && url) {
            if (offerActionType === 'Upgrade') {
                event.preventDefault();
                this.offerUrl = url;
                this.activeModal = this.modalService.open(this.upgradeOptions, { size: 'sm', windowClass: 'addlineUpgrademodal', centered: true });
            }
            else if (offerActionType === 'Device') {
                event.preventDefault();
                this.offerUrl = url;
                this.activeModal = this.modalService.open(this.upgradeAddLine, { size: 'sm', windowClass: 'upgrademodal', centered: true });
            }
            else {
                location.href = url;
                close();
            }
        }
        else {
            location.href = url;
            close();
        }
    }
    selectDeviceToUpgrade(subscriptionId) {
        this.lineToUpgrade = subscriptionId;
    }
    close() {
        if (this.activeModal) {
            this.activeModal.close();
        }
    }
}
exports.CSDealsComponent = CSDealsComponent;
//# sourceMappingURL=deals.component.js.map